import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { Deposit, Params, DepositResponse } from './types'
import { transactionRequestDirection } from '../../../billing/const'

export const depositListMounted = createEvent<Params>()
export const depositListBackendUpdated = createEvent<Params>()

export const getDeposits = fx<Params, DepositResponse>({
  method: 'GET',
  url: `/transaction_request`,
})

export const $deposits = restore<Deposit[]>(
  getDeposits.doneData.map((a) => a.body.items),
  [],
)

sample({
  clock: [depositListMounted, depositListBackendUpdated],
  fn: ({ entityId }) => {
    return {
      url: `/transaction_request?where={"clientPurseId":"${entityId}","direction":"${transactionRequestDirection.In()}"}&order[updatedAt]=DESC`,
    }
  },
  target: getDeposits,
})
